import Head from 'next/head';
import generateStructuredData, {
  IArticle,
  IBannerImg,
  IBreadcrumbs,
  ICar,
  ICustomerReview,
  IDetailUsedCar,
  IFaqs,
  IItemList,
  IProduct,
  IProductAcc,
  IVideo,
  IWebPageData,
} from '../../../helpers/utils/generateStructuredData';

interface StructuredDataProps {
  faqs?: IFaqs;
  breadcrumbs?: IBreadcrumbs;
  newsArticle?: IArticle;
  reviewArticle?: IArticle;
  customerReview?: ICustomerReview;
  product?: IProduct;
  car?: ICar;
  videoSchema?: IVideo;
  bannerImg?: IBannerImg[];
  itemList?: IItemList;
  productAccessories?: IProductAcc;
  isAccessories?: boolean;
  isPreOrderNewCar?: boolean;
  isDetailUsedCar?: boolean;
  detailUsedCar?: IDetailUsedCar;
  webpage?: IWebPageData;
}

const StructuredData = ({
  faqs,
  breadcrumbs,
  newsArticle,
  reviewArticle,
  customerReview,
  product,
  car,
  videoSchema,
  bannerImg,
  itemList,
  productAccessories,
  isAccessories = false,
  isPreOrderNewCar = false,
  isDetailUsedCar = false,
  detailUsedCar,
  webpage,
}: StructuredDataProps) => {
  const structuredData = [
    faqs?.length > 0 && generateStructuredData.faq(faqs),
    breadcrumbs?.length > 0 && generateStructuredData.breadcrumb(breadcrumbs),
    newsArticle &&
      Object.keys(newsArticle)?.length > 0 &&
      generateStructuredData.newsArticle(newsArticle),
    reviewArticle &&
      Object.keys(reviewArticle)?.length > 0 &&
      generateStructuredData.reviewArticle(reviewArticle),
    customerReview?.length > 0 && generateStructuredData.customerReview(customerReview),
    product && Object.keys(product)?.length > 0 && generateStructuredData.product(product),
    car && Object.keys(car)?.length > 0 && generateStructuredData.car(car),
    videoSchema &&
      Object.keys(videoSchema)?.length > 0 &&
      generateStructuredData.videoSchema(videoSchema),
    bannerImg && bannerImg?.map((data) => generateStructuredData.bannerImg(data)),
    itemList && generateStructuredData.itemList(itemList),
    productAccessories && generateStructuredData.productAccessories(productAccessories),
    isAccessories && generateStructuredData.website(),
    isPreOrderNewCar && generateStructuredData.website(),
    isPreOrderNewCar ? generateStructuredData.corporate() : generateStructuredData.organization(),
    isDetailUsedCar && generateStructuredData.detailUsedCar(detailUsedCar),
    webpage && generateStructuredData.webpage(webpage),
  ]
    .flat()
    .filter((data) => data);

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
    </Head>
  );
};

export default StructuredData;
